<template>
  <section class="fc">
    <div class="fc__wrap">
      <div class="fc__grid">
        <!-- Card completa clickeable -->
        <a
          v-for="(card, i) in items"
          :key="i"
          class="fc__card"
          :href="card.href"
          :target="card.external ? '_blank' : null"
          :rel="card.external ? 'noopener' : null"
          :aria-label="`Ir a ${card.title}`"
        >
          <div class="fc__avatar">
            <img :src="`/images/featured/${card.icon}.svg`" :alt="card.title" />
          </div>

          <h3 class="fc__title">{{ card.title }}</h3>

          <p v-if="card.description" class="fc__desc">{{ card.description }}</p>

          <ul v-else-if="card.bullets && card.bullets.length" class="fc__list">
            <li v-for="(b, j) in card.bullets" :key="j">{{ b }}</li>
          </ul>

          <span class="fc__cta"
            >Conoce más <img src="/images/iconos/arrow_forward.svg"/></span>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "FeatureCards",
  props: {
    items: {
      type: Array,
      default: () => [
        {
          icon: "circulo1",
          title: "Modelo educativo 360°",
          bullets: [
            "Contenidos y docentes de excelencia",
            "Ejercitación permanente",
            "Evaluación continua",
            "Orientación y apoyo permanente",
          ],
          href: "https://www.preupdv.cl/modelo-educativo-360",
          external: true,
        },
        {
          icon: "circulo2",
          title: "App Preu PDV",
          description:
            "Toda la información académica y diversos recursos de orientación en un solo lugar",
          href: "https://www.preupdv.cl/nuestros-recursos",
          external: true,
        },
        {
          icon: "circulo3",
          title: "App PDV Lab",
          description:
            "Centro de recursos virtuales, interactivos y audiovisuales para apoyar el aprendizaje",
          href: "https://www.preupdv.cl/nuestros-recursos",
          external: true,
        },
      ],
    },
  },
  methods: {
    baseUrl(path) {
      const base = process.env.BASE_URL || "/";
      return path.startsWith("/") ? path : base + path.replace(/^\/+/, "");
    },
  },
};
</script>

<style scoped>
.fc {
  padding: 24px 16px 56px;
  background: #fff;
  color: #0f172a;
  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto,
    Helvetica, Arial;
}

.fc__wrap {
  max-width: 936px;
  margin: 0 auto;
  padding: 0px;
}

.fc__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 22px;
}

/* anchor con look de card */
.fc__card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 360px;
  padding: 56px 24px 28px;
  min-height: 298px;
  border: 2px solid #CACBCE;
  border-radius: 8px 32px 8px 32px;
  background: #fff;
  text-align: center;
  text-decoration: none;
  color: inherit;
  transition: box-shadow 0.2s ease, border-color 0.2s ease, transform 0.06s ease;
  margin: 0 auto;
}

.fc__card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 8px 28px rgba(2, 6, 23, 0.06);
}

.fc__card:active {
  transform: translateY(1px);
}

.fc__card:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.35);
}

.fc__avatar {
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  height: 100px;
  border-radius: 9999px;
  overflow: hidden;
}

.fc__avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.fc__title {
  margin: 12px 0 8px;
  font-size: clamp(18px, 4vw, 28px);
  font-weight: 800;
  line-height: 1.2;
}

.fc__desc {
  font-family: "Poppins-Regular", sans-serif;
  font-weight: 400;
  font-style: Regular;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: center;
  margin: 10px auto 14px;
  max-width: 32ch;
  color: #334155;
  padding-top: 20px;
}

.fc__list {
  margin: 14px auto 16px;
  padding: 0;
  list-style: none;
  text-align: left;
  display: inline-block;
}

.fc__list li {
  position: relative;
  padding-left: 16px;
  margin: 8px 0;
  font-family: "Poppins-Regular", sans-serif;
  font-weight: 400;
  font-style: Regular;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0px;
  color: #334155;
}

.fc__list li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0.6em;
  width: 8px;
  height: 8px;
  border-radius: 9999px;
  background: #009A88;
  transform: translateY(-50%);
}

.fc__cta {
  margin-top: auto;
  font-weight: 700;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  color: #2B74AD;
  transition: text-shadow 0.3s ease, color 0.3s ease;
  font-weight: 500;
  line-height: 24px;
}

.fc__card:hover .fc__cta {
  text-shadow: 0 2px 6px rgba(29, 78, 216, 0.4);
  color: #030b26;
}

/* ===== RESPONSIVE DESIGN ===== */

/* Mobile Small (320px - 480px) */
@media (max-width: 480px) {
  .fc {
    padding: 16px 12px 40px;
  }
  
  .fc__wrap {
    padding: 0 12px;
  }
  
  .fc__grid {
    gap: 16px;
  }
  
  .fc__card {
    max-width: 100%;
    padding: 48px 16px 24px;
    min-height: 260px;
    border-radius: 6px 24px 6px 24px;
  }
  
  .fc__avatar {
    width: 80px;
    height: 80px;
    top: -32px;
  }
  
  .fc__title {
    font-size: 16px;
    margin: 8px 0 6px;
  }
  
  .fc__desc {
    font-size: 14px;
    line-height: 20px;
    padding-top: 16px;
    margin: 8px auto 12px;
  }
  
  .fc__list li {
    font-size: 11px;
    line-height: 14px;
    margin: 6px 0;
  }
  
  .fc__cta {
    font-size: 14px;
    line-height: 20px;
  }
}

/* Mobile Medium (481px - 767px) */
@media (min-width: 481px) and (max-width: 767px) {
  .fc {
    padding: 20px 16px 48px;
  }
  
  .fc__wrap {
    padding: 0 16px;
  }
  
  .fc__grid {
    gap: 18px;
  }
  
  .fc__card {
    max-width: 320px;
    padding: 52px 20px 26px;
    min-height: 280px;
  }
  
  .fc__avatar {
    width: 90px;
    height: 90px;
    top: -36px;
  }
  
  .fc__title {
    font-size: 18px;
  }
  
  .fc__desc {
    font-size: 15px;
    line-height: 22px;
  }
  
  .fc__list li {
    font-size: 11px;
    line-height: 15px;
  }
  
  .fc__cta {
    font-size: 15px;
  }
}

/* Tablet (768px - 1023px) */
@media (min-width: 768px) and (max-width: 1023px) {
  .fc {
    padding: 24px 20px 52px;
  }
  
  .fc__wrap {
    padding: 0 20px;
  }
  
  .fc__grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
  }
  
  .fc__card {
    max-width: 340px;
    padding: 54px 22px 28px;
    min-height: 290px;
  }
  
  .fc__avatar {
    width: 95px;
    height: 95px;
    top: -38px;
  }
  
  .fc__title {
    font-size: 20px;
  }
  
  .fc__desc {
    font-size: 15px;
    line-height: 23px;
  }
  
  .fc__list li {
    font-size: 12px;
    line-height: 16px;
  }
  
  .fc__cta {
    font-size: 15px;
  }
}

/* Desktop (1024px - 1279px) */
@media (min-width: 1024px) and (max-width: 1279px) {
  .fc {
    padding: 24px 24px 56px;
  }
  
  .fc__wrap {
    padding: 0px;
  }
  
  .fc__grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 26px;
  }
  
  .fc__card {
    max-width: 360px;
    padding: 56px 24px 28px;
    min-height: 298px;
  }
  
  .fc__avatar {
    width: 100px;
    height: 100px;
    top: -40px;
  }
  
  .fc__title {
    font-size: 22px;
  }
  
  .fc__desc {
    font-size: 16px;
    line-height: 24px;
  }
  
  .fc__list li {
    font-size: 12px;
    line-height: 16px;
  }
  
  .fc__cta {
    font-size: 16px;
  }
}

/* Large Desktop (1280px+) */
@media (min-width: 1280px) {
  .fc {
    padding: 0px;
  }
  
  .fc__wrap {
    padding: 0px;
  }
  
  .fc__grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 28px;
  }
  
  .fc__card {
    max-width: 380px;
    padding: 60px 26px 30px;
    min-height: 320px;
  }
  
  .fc__avatar {
    width: 110px;
    height: 110px;
    top: -44px;
  }
  
  .fc__title {
    font-size: 24px;
  }
  
  .fc__desc {
    font-size: 17px;
    line-height: 26px;
  }
  
  .fc__list li {
    font-size: 13px;
    line-height: 18px;
  }
  
  .fc__cta {
    font-size: 17px;
  }
}

/* Extra Large Desktop (1440px+) */
@media (min-width: 1440px) {
  .fc__grid {
    gap: 32px;
  }
  
  .fc__card {
    max-width: 400px;
    padding: 64px 28px 32px;
    min-height: 340px;
  }
  
  .fc__avatar {
    width: 120px;
    height: 120px;
    top: -48px;
  }
  
  .fc__title {
    font-size: 26px;
  }
  
  .fc__desc {
    font-size: 18px;
    line-height: 28px;
  }
  
  .fc__list li {
    font-size: 14px;
    line-height: 20px;
  }
  
  .fc__cta {
    font-size: 18px;
  }
}

/* Landscape Mobile */
@media (max-height: 500px) and (orientation: landscape) {
  .fc {
    padding: 16px 16px 32px;
  }
  
  .fc__card {
    min-height: 240px;
    padding: 40px 20px 20px;
  }
  
  .fc__avatar {
    width: 70px;
    height: 70px;
    top: -28px;
  }
  
  .fc__title {
    font-size: 16px;
    margin: 6px 0 4px;
  }
  
  .fc__desc {
    font-size: 14px;
    line-height: 20px;
    padding-top: 12px;
    margin: 6px auto 10px;
  }
  
  .fc__list li {
    font-size: 10px;
    line-height: 14px;
    margin: 4px 0;
  }
  
  .fc__cta {
    font-size: 14px;
    line-height: 18px;
  }
}

/* High DPI displays */
@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
  .fc__card {
    border-width: 1px;
  }
}

/* Print styles */
@media print {
  .fc {
    background: white;
    padding: 20px;
  }
  
  .fc__card {
    border: 1px solid #ccc;
    box-shadow: none;
    break-inside: avoid;
  }
  
  .fc__avatar {
    filter: grayscale(100%);
  }
}

/* Accessibility improvements */
@media (prefers-reduced-motion: reduce) {
  .fc__card {
    transition: none;
  }
  
  .fc__card:hover {
    transform: none;
  }
  
  .fc__card:active {
    transform: none;
  }
}
</style>
